import { accessGuard, getServerURL } from "../shared/sharedFunctions";
import userService from "./userService";

const DomainService = () => {
	const pub = {};
	
	let domains = null;
	pub.Domains = () => { return domains; };
	pub.VisibleDomains = () => {
		if (!domains) {
			return [];
		}
		return domains.filter(domain => !domain.hidden);
	};
	pub.VisibleDomainAddresses = () => {
		const visibleDomains = pub.VisibleDomains();
		return visibleDomains.map(domain => domain.address);
	};

	pub.companyServices = null;
	pub.companyServiceTypes = null;
	
	const init = () => {
	};

	pub.all = async (companyId) => {
		if (!accessGuard([1, 2, 3])) throw new Error("Unauthorised");
	
		// Get domains
		let req = {
			method: "GET",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
		};
		
		let response = await fetch(`${getServerURL()}/api/domain/domains/${companyId}`, req)
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} getting domains`);
		}
		let data = await response.json();
		
		domains = data.domains;

		// Get company services
		req = {
			method: "GET",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
		};

		response = await fetch(`${getServerURL()}/api/domain/services/${companyId}`, req);
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} getting company services`);
		}
		data = await response.json();

		pub.companyServices = data.services;
		
		pub.companyServiceTypes = [];
		for (let i in pub.companyServices) {
			const types = pub.companyServices[i].types.split("~");
			for (let j in types) {
				if (types[j] === "") continue;
				
				if (!pub.companyServiceTypes.hasOwnProperty(types[j])) {
					pub.companyServiceTypes[types[j]] = 0;
				}
				pub.companyServiceTypes[types[j]] += 1;
			}
		}
	};
	
	pub.updateDomain = async (domain) => {
		if (!accessGuard([1, 2, 3])) throw new Error("Unauthorised");
		
		for (let i in domains) {
			if (domains[i].address === domain.address) {				
				const req = {
					method: "POST",
					headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
					body: JSON.stringify({
						id: domains[i].id,
						hidden: domain.hidden,
						hidden_reason: domain.hidden_reason,
					})
				};
				
				const response = await fetch(`${getServerURL()}/api/domain/domain`, req);
				if (response.status !== 200) {
					throw new Error(`response status ${response.status} updating domain`);
				}
				const data = await response.json();
				
				domains[i] = data.domain;
				
				break;
			}
		}
	};
	
	init();
	return pub;
};

export default DomainService();
